import React, { useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { PopoverErrorBoundary } from '@/components/ErrorBoundaries/PopoverErrorBoundary';
import { Headline } from '@/types';
import { HeadlineCircle } from '@/components/shared/HeadlineCircle';
import { formatTimeAgo } from '@/utils/utils';

interface HeadlinePopoverProps {
  children: React.ReactNode;
  headlines: Headline[];
  className?: string;
}

export function HeadlinePopover({ 
  children, 
  headlines,
  className = '' 
}: HeadlinePopoverProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <PopoverErrorBoundary>
      <Popover
        isOpen={isPopoverOpen}
        positions={['bottom']}
        align="start"
        padding={5}
        reposition={false}
        containerStyle={{ zIndex: '100' }}
        content={() => (
          <div className="pt-1">
            <div 
              className="bg-white p-2 rounded-md shadow-lg border border-gray-200"
              style={{
                width: '600px',
                transform: 'translate(-20px, -8px)',
              }}
              onMouseEnter={() => setIsPopoverOpen(true)}
              onMouseLeave={() => setIsPopoverOpen(false)}
            >
              <div className="space-y-1">
                {headlines.map((headline) => (
                  <a
                    key={headline.content_id}
                    href={headline.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 py-1 px-2 hover:bg-muted rounded-sm transition-colors group"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <HeadlineCircle headline={headline} />
                    <div className="min-w-0 flex-1">
                      <div className="overflow-hidden relative">
                        <div className="flex items-center text-[0.8em]">
                          <div className="flex-1 whitespace-nowrap group-hover:animate-marquee-fixed">
                            <span className="pr-4">
                              {headline.text_context && (
                                <span className="text-muted-foreground mr-1">[{headline.text_context}]</span>
                              )}
                              {headline.title || 'Untitled'}
                            </span>
                            <span className="pr-4">
                              {headline.text_context && (
                                <span className="text-muted-foreground mr-1">[{headline.text_context}]</span>
                              )}
                              {headline.title || 'Untitled'}
                            </span>
                          </div>
                          <div className="text-muted-foreground ml-2 whitespace-nowrap shrink-0">
                            ({formatTimeAgo(new Date(headline.published_date || ''))})
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      >
        <div 
          className={className}
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
        >
          {children}
        </div>
      </Popover>
    </PopoverErrorBoundary>
  );
} 